export class StepIssuesDto {
    controls;
    integration;
}
export var UiSchemaGroupEnum;
(function (UiSchemaGroupEnum) {
    UiSchemaGroupEnum["IN_APP"] = "IN_APP";
    UiSchemaGroupEnum["EMAIL"] = "EMAIL";
    UiSchemaGroupEnum["DIGEST"] = "DIGEST";
    UiSchemaGroupEnum["DELAY"] = "DELAY";
    UiSchemaGroupEnum["THROTTLE"] = "THROTTLE";
    UiSchemaGroupEnum["SMS"] = "SMS";
    UiSchemaGroupEnum["CHAT"] = "CHAT";
    UiSchemaGroupEnum["PUSH"] = "PUSH";
    UiSchemaGroupEnum["SKIP"] = "SKIP";
    UiSchemaGroupEnum["LAYOUT"] = "LAYOUT";
    UiSchemaGroupEnum["HTTP_REQUEST"] = "HTTP_REQUEST";
})(UiSchemaGroupEnum || (UiSchemaGroupEnum = {}));
export var UiComponentEnum;
(function (UiComponentEnum) {
    UiComponentEnum["EMAIL_EDITOR_SELECT"] = "EMAIL_EDITOR_SELECT";
    UiComponentEnum["LAYOUT_SELECT"] = "LAYOUT_SELECT";
    /** @deprecated use EMAIL_BODY instead  */
    UiComponentEnum["BLOCK_EDITOR"] = "BLOCK_EDITOR";
    UiComponentEnum["EMAIL_BODY"] = "EMAIL_BODY";
    UiComponentEnum["TEXT_FULL_LINE"] = "TEXT_FULL_LINE";
    UiComponentEnum["TEXT_INLINE_LABEL"] = "TEXT_INLINE_LABEL";
    UiComponentEnum["IN_APP_BODY"] = "IN_APP_BODY";
    UiComponentEnum["IN_APP_AVATAR"] = "IN_APP_AVATAR";
    UiComponentEnum["IN_APP_SUBJECT"] = "IN_APP_PRIMARY_SUBJECT";
    UiComponentEnum["IN_APP_BUTTON_DROPDOWN"] = "IN_APP_BUTTON_DROPDOWN";
    UiComponentEnum["IN_APP_DISABLE_SANITIZATION_SWITCH"] = "IN_APP_DISABLE_SANITIZATION_SWITCH";
    UiComponentEnum["DISABLE_SANITIZATION_SWITCH"] = "DISABLE_SANITIZATION_SWITCH";
    UiComponentEnum["URL_TEXT_BOX"] = "URL_TEXT_BOX";
    UiComponentEnum["DIGEST_AMOUNT"] = "DIGEST_AMOUNT";
    UiComponentEnum["DIGEST_UNIT"] = "DIGEST_UNIT";
    UiComponentEnum["DIGEST_TYPE"] = "DIGEST_TYPE";
    UiComponentEnum["DIGEST_KEY"] = "DIGEST_KEY";
    UiComponentEnum["DIGEST_CRON"] = "DIGEST_CRON";
    UiComponentEnum["DELAY_AMOUNT"] = "DELAY_AMOUNT";
    UiComponentEnum["DELAY_UNIT"] = "DELAY_UNIT";
    UiComponentEnum["DELAY_TYPE"] = "DELAY_TYPE";
    UiComponentEnum["DELAY_CRON"] = "DELAY_CRON";
    UiComponentEnum["DELAY_DYNAMIC_KEY"] = "DELAY_DYNAMIC_KEY";
    UiComponentEnum["THROTTLE_TYPE"] = "THROTTLE_TYPE";
    UiComponentEnum["THROTTLE_WINDOW"] = "THROTTLE_WINDOW";
    UiComponentEnum["THROTTLE_UNIT"] = "THROTTLE_UNIT";
    UiComponentEnum["THROTTLE_DYNAMIC_KEY"] = "THROTTLE_DYNAMIC_KEY";
    UiComponentEnum["THROTTLE_THRESHOLD"] = "THROTTLE_THRESHOLD";
    UiComponentEnum["THROTTLE_KEY"] = "THROTTLE_KEY";
    UiComponentEnum["EXTEND_TO_SCHEDULE"] = "EXTEND_TO_SCHEDULE";
    UiComponentEnum["SMS_BODY"] = "SMS_BODY";
    UiComponentEnum["CHAT_BODY"] = "CHAT_BODY";
    UiComponentEnum["PUSH_BODY"] = "PUSH_BODY";
    UiComponentEnum["PUSH_SUBJECT"] = "PUSH_SUBJECT";
    UiComponentEnum["QUERY_EDITOR"] = "QUERY_EDITOR";
    UiComponentEnum["DATA"] = "DATA";
    UiComponentEnum["LAYOUT_EMAIL"] = "LAYOUT_EMAIL";
    UiComponentEnum["DESTINATION_METHOD"] = "DESTINATION_METHOD";
    UiComponentEnum["DESTINATION_URL"] = "DESTINATION_URL";
    UiComponentEnum["DESTINATION_HEADERS"] = "DESTINATION_HEADERS";
    UiComponentEnum["DESTINATION_BODY"] = "DESTINATION_BODY";
    UiComponentEnum["DESTINATION_RESPONSE_BODY_SCHEMA"] = "DESTINATION_RESPONSE_BODY_SCHEMA";
    UiComponentEnum["DESTINATION_ENFORCE_SCHEMA_VALIDATION"] = "DESTINATION_ENFORCE_SCHEMA_VALIDATION";
    UiComponentEnum["DESTINATION_CONTINUE_ON_FAILURE"] = "DESTINATION_CONTINUE_ON_FAILURE";
    UiComponentEnum["DESTINATION_TIMEOUT"] = "DESTINATION_TIMEOUT";
})(UiComponentEnum || (UiComponentEnum = {}));
export class UiSchemaProperty {
    placeholder;
    component;
    properties;
}
export class UiSchema {
    group;
    properties;
}
export class Controls {
    dataSchema;
    uiSchema;
    values;
}
//# sourceMappingURL=step.dto.js.map